import { render, staticRenderFns } from "./myLicenses.vue?vue&type=template&id=23747c33&scoped=true"
import script from "./myLicenses.vue?vue&type=script&lang=js"
export * from "./myLicenses.vue?vue&type=script&lang=js"
import style0 from "./myLicenses.vue?vue&type=style&index=0&id=23747c33&prod&lang=less&scoped=true"
import style1 from "./myLicenses.vue?vue&type=style&index=1&id=23747c33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23747c33",
  null
  
)

export default component.exports